import HeaderOne from './component.styles'
export default HeaderOne
